export interface ITest {
  xTime: number[]
  xMil: number[]
  yVolume: number[]
  yFlow: number[]
  createtime: string
  markStart: string
  markEnd: string
}
export default class Test implements ITest {
  xTime: number[] = []
  xMil: number[] = []
  yVolume: number[] = []
  yFlow: number[] = []
  createtime: string = ''
  input: string[] = []
  markStart: string = ''
  markEnd: string = ''

  fromJson (input: any) : Test {
    this.xMil = input.x
    this.xTime = input.x
    this.yVolume = input.yVolume
    this.yFlow = input.yFlow
    this.markStart = input.mark_start
    this.markEnd = input.mark_end

    this.input = input

    return this
  }
}
